if (typeof Intl === 'undefined')
  require.ensure([], () => {
    require('intl')
    require('intl/locale-data/jsonp/en.js')
    require('intl/locale-data/jsonp/es.js')
    require('intl/locale-data/jsonp/pt.js')
  }, 'Intl')

if (!(
    'startsWith' in String.prototype &&
    'endsWith' in String.prototype &&
    'includes' in Array.prototype &&
    'assign' in Object &&
    'keys' in Object
  )) {
  require.ensure([], () => {
    require('core-js')
  }, 'core-js')
}



// WEBPACK FOOTER //
// ./sef/static/js/polyfills.js